import { render, staticRenderFns } from "./GameDemo.vue?vue&type=template&id=6a4f2c4a&"
import script from "./GameDemo.vue?vue&type=script&lang=js&"
export * from "./GameDemo.vue?vue&type=script&lang=js&"
import style0 from "./GameDemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports